import { Button } from '@/components/ui/button';
import { Send, X, Check, Loader2 } from 'lucide-react';

interface ChatInputActionsProps {
  isEditingDraft: boolean;
  onCancelEdit?: () => void;
  onSend: () => void;
  disabled: boolean;
  hasContent: boolean;
  isSending: boolean;
  isAutoSaving: boolean;
}

export function ChatInputActions({
  isEditingDraft,
  onCancelEdit,
  onSend,
  disabled,
  hasContent,
  isSending,
  isAutoSaving
}: ChatInputActionsProps) {
  if (isEditingDraft) {
    return (
      <>
        <Button
          size="xs"
          density="compact"
          gap="standard"
          type="button"
          variant="outline"
          onClick={() => onCancelEdit?.()}
          className="shrink-0"
        >
          <X className="h-3.5 w-3.5" />
          Cancel
        </Button>
        <Button
          size="xs"
          density="compact"
          gap="standard"
          type="button"
          onClick={onSend}
          disabled={disabled || !hasContent}
          className="shrink-0"
        >
          <Check className="h-3.5 w-3.5" />
          Update draft
        </Button>
      </>
    );
  }

  return (
    <Button
      size="xs"
      density="compact"
      gap="standard"
      type="button"
      onClick={onSend}
      disabled={disabled || !hasContent || isSending || isAutoSaving}
      className="shrink-0"
    >
      {isSending || isAutoSaving ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <Send className="h-3.5 w-3.5" />
      )}
      {isSending
        ? 'Sending...'
        : isAutoSaving
          ? 'Saving draft...'
          : 'Send message'}
    </Button>
  );
}
